'use client';

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';
import { GlobalDesktopSideAdBanner } from '@/app/_components/ads';
import { LoadingPageTemplate } from '@/components/client';
import { DesktopPageShell } from '@/components/template/DesktopPageShell';
import { useAppBack } from '@/modules/wello-app/_hooks/useAppBack';
import { useAuthStore } from '@/stores/AuthStore';
import { ChatbotFlow } from './_components/ChatbotFlow';
import { Header } from './_components/Header';
import { PolicyContent } from './_components/PolicyContent';
import { PolicyContentSkeleton } from './_components/PolicyContentSkeleton';
import { PolicyFilter } from './_components/PolicyFilter';
import { PolicyListErrorBoundary } from './_components/PolicyListErrorBoundary';
import { StatisticsCard } from './_components/StatisticsCard';
import { StatisticsCardSkeleton } from './_components/StatisticsCardSkeleton';
import { StatisticsErrorBoundary } from './_components/StatisticsErrorBoundary';
import type { FilterType, SortType, ViewMode } from './_types/types';
const RecommendPolicyPage = () => {
  const $ = _c(29);
  useAppBack();
  const searchParams = useSearchParams();
  const myInfo = useAuthStore(_temp);
  if (myInfo === undefined) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <LoadingPageTemplate />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  if (!myInfo) {
    let t0;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div className="flex flex-1 flex-col bg-Gray-50"><DesktopPageShell><ChatbotFlow /></DesktopPageShell></div>;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let t0;
  if ($[2] !== searchParams) {
    t0 = searchParams.get("sort") as SortType ?? "PRIORITY";
    $[2] = searchParams;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const sort = t0;
  let t1;
  if ($[4] !== searchParams) {
    t1 = searchParams.get("filter");
    $[4] = searchParams;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const filter = t1 as FilterType | undefined;
  let t2;
  if ($[6] !== searchParams) {
    t2 = searchParams.get("viewMode") as ViewMode ?? "timeline";
    $[6] = searchParams;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const viewMode = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <GlobalDesktopSideAdBanner />;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      background: "linear-gradient(to bottom, rgb(221, 242, 255) 0px, rgb(249, 249, 249) 400px, rgb(249, 249, 249))"
    };
    t5 = <h1 className="sr-only">맞춤 정책 추천</h1>;
    t6 = <Header />;
    t7 = <PolicyFilter />;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <StatisticsCardSkeleton />;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== sort) {
    t9 = <StatisticsErrorBoundary><Suspense fallback={t8}><StatisticsCard sort={sort} /></Suspense></StatisticsErrorBoundary>;
    $[14] = sort;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== viewMode) {
    t10 = <PolicyContentSkeleton viewMode={viewMode} />;
    $[16] = viewMode;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== filter || $[19] !== sort || $[20] !== viewMode) {
    t11 = <PolicyContent sort={sort} filter={filter} viewMode={viewMode} />;
    $[18] = filter;
    $[19] = sort;
    $[20] = viewMode;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11 || $[24] !== viewMode) {
    t12 = <PolicyListErrorBoundary><Suspense key={viewMode} fallback={t10}>{t11}</Suspense></PolicyListErrorBoundary>;
    $[22] = t10;
    $[23] = t11;
    $[24] = viewMode;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t9) {
    t13 = <DesktopPageShell className="pt-40 mobile-tablet:pt-0" mainClassName="flex flex-col" rightAside={t3}><div className="flex w-full flex-col" style={t4}>{t5}{t6}{t7}{t9}{t12}</div></DesktopPageShell>;
    $[26] = t12;
    $[27] = t9;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
};
export default RecommendPolicyPage;
function _temp(state) {
  return state.myInfo;
}